import usePrivateAxios from "@/common/api/usePrivateAxios";
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant";
import { Mapper } from "@/common/services/mapper";
import { MetaResponse } from "@/common/types/metaResponse";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

type UseClientCompanyBranchesEquipmentsConsumptionsTotalizerProps<T> = {
  companyId: string | undefined;
  filters?: {
    clientBranchId?: string;
    consumptionCreatedAtGteq?: string;
    consumptionCreatedAtLteq?: string;
  };
  mapper?: (data: any) => T;
}

export const useClientCompanyBranchesEquipmentsConsumptionsTotalizer = <T,>({
  companyId,
  filters: {
    clientBranchId,
    consumptionCreatedAtGteq,
    consumptionCreatedAtLteq,
  } = {},
  mapper = Mapper.default<T>(),
}: UseClientCompanyBranchesEquipmentsConsumptionsTotalizerProps<T>) => {
  const privateAxios = usePrivateAxios();

  const {
    data: { data, meta } = defaultTransformerResponse(),
    ...rest
  } = useQuery({
    queryKey: [
      'clientCompanyBranchesEquipmentsConsumptionsTotalizer',
      companyId,
      clientBranchId,
      consumptionCreatedAtGteq,
      consumptionCreatedAtLteq,
    ],
    queryFn: () => {
      return privateAxios.get(`/client/companies/${companyId}/branches_equipments_consumptions_totalizer`, {
        params: {
          'q[client_branch_id_eq]': clientBranchId,
          'q[consumption_created_at_gteq]': consumptionCreatedAtGteq,
          'q[consumption_created_at_lteq]': consumptionCreatedAtLteq,
        }
      });
    },
    select: (data: { data: { data: any[], meta: MetaResponse; } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  });

  return { data, meta, ...rest };
}
